/* ───────────────────────────────────────────────────────────────
   RAIL PRODUITS — SOLEIL D'OR
   v1.0 — 20/09/2026

   Pilote les rangées qui défilent, côté flèches et état.
   Le défilement lui-même est natif (overflow-x + scroll-snap) :
   ce fichier ne fait que déplacer la position et tenir les
   boutons à jour. Rien ne dépend de lui pour que le rail
   fonctionne au doigt ou au clavier.

   Un rail qui ne déborde pas n'affiche pas ses flèches :
   l'attribut data-sdo-debordement porte cet état, et la CSS
   s'en sert. Recalculé au redimensionnement et quand le contenu
   change — le script du profil local réordonne les fiches après
   coup.
   ─────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function pas(piste) {
    /* Un « écran » de rail, moins un chevauchement pour garder
       un repère visuel entre deux pressions. */
    return Math.max(160, Math.round(piste.clientWidth * 0.8));
  }

  function majEtat(wrap, piste, avant, apres) {
    var deborde = piste.scrollWidth > piste.clientWidth + 2;
    wrap.setAttribute('data-sdo-debordement', deborde ? 'oui' : 'non');
    if (!deborde) return;
    var max = piste.scrollWidth - piste.clientWidth;
    var x = piste.scrollLeft;
    if (avant) {
      if (x <= 2) avant.setAttribute('disabled', 'disabled');
      else avant.removeAttribute('disabled');
    }
    if (apres) {
      if (x >= max - 2) apres.setAttribute('disabled', 'disabled');
      else apres.removeAttribute('disabled');
    }
  }

  function brancher(wrap) {
    if (wrap.dataset.sdoRailPret === '1') return;
    var piste = wrap.querySelector('.sdo-rail');
    if (!piste) return;
    wrap.dataset.sdoRailPret = '1';

    /* 14/10/2026 : un <ul> en role="group" perd sa nature de liste et ses
       <li> deviennent orphelins (accessibilité, lecture par les agents). */
    if (piste.tagName === 'UL' && piste.getAttribute('role') === 'group') {
      piste.setAttribute('role', 'list');
    }

    var avant = wrap.querySelector('.sdo-rail__fleche--avant');
    var apres = wrap.querySelector('.sdo-rail__fleche--apres');

    if (avant) {
      avant.addEventListener('click', function () {
        piste.scrollBy({ left: -pas(piste), behavior: 'smooth' });
      });
    }
    if (apres) {
      apres.addEventListener('click', function () {
        piste.scrollBy({ left: pas(piste), behavior: 'smooth' });
      });
    }

    var minuteur = null;
    piste.addEventListener(
      'scroll',
      function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          majEtat(wrap, piste, avant, apres);
        }, 80);
      },
      { passive: true }
    );

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        majEtat(wrap, piste, avant, apres);
      }).observe(piste);
    } else {
      window.addEventListener('resize', function () {
        majEtat(wrap, piste, avant, apres);
      });
    }

    /* Le profil local réordonne les fiches après le rendu :
       l'état est recalculé quand la liste bouge. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        majEtat(wrap, piste, avant, apres);
      }).observe(piste, { childList: true });
    }

    majEtat(wrap, piste, avant, apres);
    /* Les images arrivent après : un second passage évite des
       flèches masquées à tort sur un rail encore étroit. */
    setTimeout(function () { majEtat(wrap, piste, avant, apres); }, 800);
  }

  function demarrer() {
    var rails = document.querySelectorAll('[data-sdo-rail]');
    for (var i = 0; i < rails.length; i++) brancher(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }

  /* Personnalisateur de thème : les sections sont rechargées. */
  document.addEventListener('shopify:section:load', demarrer);
})();